import styled from 'styled-components';
import Button from '@minecraft.button';
import { Form } from 'formik';

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FieldWrapper = styled.div`
  width: 60%;
  margin-top: 1rem;

  button {
    right: 2px;
  }

  label {
    font-weight: bold;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 2rem;
`;

export const StyledLinkButton = styled(Button)`
  color: ${({ theme }): string => theme.colors.primary.primary};
  text-decoration: none;
  outline: none;
  display: block;
  padding: 0;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }): string => theme.colors.primary.primary};
  }
`;

export const Msg = styled.div``;
